import { render, staticRenderFns } from "./CartRecommendProductItem.vue?vue&type=template&id=6ed76454"
import script from "./CartRecommendProductItem.vue?vue&type=script&lang=js"
export * from "./CartRecommendProductItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports